<div class="paginator">
  <div class="page-size">
    Show
    <select class="form-control input-sm" [(ngModel)]="pageSize" (change)="onPageSizeSelect($event)">
      <option *ngFor="let pageSizeOption of pageSizeOptions" [value]="pageSizeOption">{{ pageSizeOption }}</option>
    </select>
    entries
  </div>

  <div class="shown-entries">Showing {{ from }} - {{ to }} of {{ length }} entries</div>

  <ul class="pagination">
    <li [ngClass]="{'disabled': !isFirstPage}">
      <a role="button" (click)="onFirstPageClick()">«</a>
    </li>

    <li *ngFor="let pageItem of pageItems"
      [ngClass]="{'active': pageItem.index === pageIndex, 'disabled': pageItem.index === undefined}">
      <a role="button" *ngIf="pageItem.index !== undefined" (click)="onPageClick(pageItem.index)">
        {{ pageItem.index + 1 }}
      </a>
      <a role="button" *ngIf="pageItem.index === undefined">...</a>
    </li>

    <li [ngClass]="{'disabled': !isLastPage}">
      <a role="button" (click)="onLastPageClick()">»</a>
    </li>
  </ul>
</div>
